import {  Fragment,  useEffect, useMemo, useState } from "react";
import React from "react";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetWBComponentByTypename } from "./Data/WBData";





//Wrap all components in this class in order to target and rerender specific components instead of the enitre layout when updating layoutnodes
export default function WBComponentWrapper (props: WBRenderProps) {



    const RenderC = useMemo(()=>GetWBComponentByTypename(props.component.typename).RenderLayout,[props.component.typename]);

    const [,setUpdateToggle] = useState(0);

    useEffect(()=>{
        props.component.forceUpdate = ()=>{setUpdateToggle((prev)=>prev+1)};

        return () => {
            props.component.forceUpdate = ()=>{console.error("no update")};
        }
        // eslint-disable-next-line
    },[]);



        return <Fragment>
                <RenderC  {...props} >
                {props.children}
                </RenderC>
            </Fragment>



}